/* Bind once: Shopify can render this shared snippet more than once. */
if (!window.beleaevBenefitsToggleBound) {
  window.beleaevBenefitsToggleBound = true;
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('.bel-benefits-toggle');
    const wrapper = button?.closest('.bel-benefits-wrap');
    if (!wrapper) return;
    const paused = button.getAttribute('aria-pressed') !== 'true';
    button.setAttribute('aria-pressed', String(paused));
    button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
    wrapper.toggleAttribute('data-paused', paused);
  });
}
